/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-1",
    "aws_appsync_graphqlEndpoint": "https://akq4scmwrnb6hosx4ekddti5jm.appsync-api.us-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-1",
    "aws_appsync_authenticationType": "AWS_IAM",
    "aws_cloud_logic_custom": [
        {
            "name": "establishmentAPI",
            "endpoint": "https://im5jckk450.execute-api.us-west-1.amazonaws.com/staging",
            "region": "us-west-1"
        },
        {
            "name": "gustoAPI",
            "endpoint": "https://be90md7ke2.execute-api.us-west-1.amazonaws.com/staging",
            "region": "us-west-1"
        },
        {
            "name": "hrisDataAPI",
            "endpoint": "https://kfw6lpqh0j.execute-api.us-west-1.amazonaws.com/staging",
            "region": "us-west-1"
        },
        {
            "name": "machineLearningAPI",
            "endpoint": "https://384fcibi60.execute-api.us-west-1.amazonaws.com/staging",
            "region": "us-west-1"
        },
        {
            "name": "mergeAPI",
            "endpoint": "https://z8sr2411tf.execute-api.us-west-1.amazonaws.com/staging",
            "region": "us-west-1"
        },
        {
            "name": "mergeCredentialAPI",
            "endpoint": "https://id04xvn7m2.execute-api.us-west-1.amazonaws.com/staging",
            "region": "us-west-1"
        },
        {
            "name": "oneschemaAPI",
            "endpoint": "https://em10hy065j.execute-api.us-west-1.amazonaws.com/staging",
            "region": "us-west-1"
        },
        {
            "name": "reportResultAPI",
            "endpoint": "https://bshcpkqael.execute-api.us-west-1.amazonaws.com/staging",
            "region": "us-west-1"
        },
        {
            "name": "stripeAPI",
            "endpoint": "https://aziht2m3af.execute-api.us-west-1.amazonaws.com/staging",
            "region": "us-west-1"
        },
        {
            "name": "stripeWebhookAPI",
            "endpoint": "https://44a2wey351.execute-api.us-west-1.amazonaws.com/staging",
            "region": "us-west-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-west-1:2aaff711-fe23-4a2b-bfac-7b4e2e51bcab",
    "aws_cognito_region": "us-west-1",
    "aws_user_pools_id": "us-west-1_kFD4fJCik",
    "aws_user_pools_web_client_id": "mcocu06rpsk9b65j2int7f28v",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "dolphin-storage105738-staging",
    "aws_user_files_s3_bucket_region": "us-west-1"
};


export default awsmobile;
